import { getJson } from './fetch-helpers.ts';

/*
 * The page's config: normally the config.json served next to the page, but
 * a page whose config is per-viewer (a student project's, built from its
 * database row — plans/student-projects.md) renders it inline instead,
 * because a reviewing teacher's relative config.json fetch drops the
 * ?student= query, leaving no way for a route to know whose config to
 * answer with. The layouts emit the inline copy as a JSON script block when
 * given a `config` local; official pages don't, and fetch as always.
 */
export const pageConfig = async <T>(): Promise<T> => {
  const embedded = document.getElementById('page-config')?.textContent;
  if (embedded) return JSON.parse(embedded) as T;
  return await getJson<T>('config.json');
};
